import CookieUtils from "./cookieUtils";

export const CONTENT_ONLY_QUERY_PARAM = "contentOnly";
export const CONTENT_ONLY_COOKIE_NAME = "content-only";

export class ContentOnlyMode {
    public static init() {
        const search = new URLSearchParams(window.location.search);

        if (search.get(CONTENT_ONLY_QUERY_PARAM) !== "true") {
            return;
        }

        CookieUtils.setCookie(CONTENT_ONLY_COOKIE_NAME, "true", 1, "Lax");
    }
}
